/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_action__close_panel = /** @type {(inputs: {}) => string} */ () => {
	return `Panel verkleinern`
};

const en_action__close_panel = /** @type {(inputs: {}) => string} */ () => {
	return `Minimize panel`
};

const es_action__close_panel = /** @type {(inputs: {}) => string} */ () => {
	return `Reducir panel`
};

const fr_action__close_panel = /** @type {(inputs: {}) => string} */ () => {
	return `Réduire le panneau`
};

const it_action__close_panel = /** @type {(inputs: {}) => string} */ () => {
	return `Ridurre il pannello`
};

const nl_action__close_panel = /** @type {(inputs: {}) => string} */ () => {
	return `Paneel verkleinen`
};

const pt_action__close_panel = /** @type {(inputs: {}) => string} */ () => {
	return `Reduzir o painel`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const action__close_panel = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.action__close_panel(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("action__close_panel", locale)
	if (locale === "de") return de_action__close_panel(inputs)
	if (locale === "en") return en_action__close_panel(inputs)
	if (locale === "es") return es_action__close_panel(inputs)
	if (locale === "fr") return fr_action__close_panel(inputs)
	if (locale === "it") return it_action__close_panel(inputs)
	if (locale === "nl") return nl_action__close_panel(inputs)
	return pt_action__close_panel(inputs)
};